import React, { useEffect, useState } from 'react';

import MHDRequests from 'services/MHDRequests';
import { useEHRContext } from 'contexts/EHRContext';
import './DocumentsVisualizer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

export function DocumentsVisualizer({ modalContent }) {
  const { ehrState } = useEHRContext();
  const [base64, setBase64] = useState({});

  const binaryType = base64?.contentType;
  const binaryData = base64?.data;
  const binarySrc = `data:${binaryType};charset=utf-8;base64,${binaryData}`;

  function downloadBase64File() {
    const linkSource = binarySrc;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = 'Arquivo assinado';
    downloadLink.click();
  }

  useEffect(() => {
    async function asyncCalls() {
      let req;
      try {
        req = await MHDRequests.getDocuments({
          binaryId: modalContent.link,
          organizationId: ehrState.subject.organizationId,
          subjectToken: ehrState.subject.token,
          subjectId: ehrState.subject.id,
          subjectRole: '',
          purposeOfUse: ehrState.resource.purposeOfUse,
        });
        setBase64(req);
      } catch (err) {
        req = [];
        console.log(err);
      }
    }

    asyncCalls();
  }, [modalContent.link]);

  return (
    <div className={base64.contentType === 'text/html' ? 'uniqueModal-html' : 'uniqueModal-pdf'}>
      {
        base64.contentType === 'text/html'
        && (
          <div className="uniqueModal-buttons">
            <button onClick={() => downloadBase64File()}>
              {' '}
              <FontAwesomeIcon size="50" icon={faDownload}> </FontAwesomeIcon>
              {' '}
            </button>
          </div>
        )
      }

      <div style={{ width: '100%' }} className={base64.contentType === 'text/html' && 'uniqueModal-content'}>
        <div>

          {
            (base64.contentType && base64.data) && (
              <iframe
                className={base64.contentType === 'text/html' && 'iframe-html'}
                title="iframe"
                src={`${binarySrc}#zoom=125&navpanes=0`}
                type={binaryType}
                width="100%"
                height="600"
              />
            )
          }
        </div>

      </div>
    </div>

  );
}
